export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
            <div className="sm:col-span-2 lg:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-movie-2-fill text-background-50 text-lg"></i>
                </div>
                <span className="font-heading text-xl font-bold text-background-50">555电影网</span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed mb-4">
                555电影网是国内领先的4K超清影视在线平台，提供海量4K电影、超清电视剧、纪录片等高品质影视资源。极致画质，流畅不缓冲，让每个人都能够享受影院级的观影体验。
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-400 hover:text-primary-400 hover:bg-background-700 cursor-pointer transition-colors" aria-label="微博">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-400 hover:text-primary-400 hover:bg-background-700 cursor-pointer transition-colors" aria-label="微信">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-400 hover:text-primary-400 hover:bg-background-700 cursor-pointer transition-colors" aria-label="哔哩哔哩">
                  <i className="ri-bilibili-line"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base font-bold text-background-50 mb-4">快速导航</h4>
              <nav className="flex flex-col gap-2.5">
                <a href="#media" className="text-sm text-background-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">精彩推荐</a>
                <a href="#cards" className="text-sm text-background-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">影视专题</a>
                <a href="#ranking" className="text-sm text-background-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">热门榜单</a>
                <a href="#updates" className="text-sm text-background-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">最新动态</a>
                <a href="#index" className="text-sm text-background-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">影视索引</a>
              </nav>
            </div>

            <div>
              <h4 className="font-heading text-base font-bold text-background-50 mb-4">内容分类</h4>
              <nav className="flex flex-col gap-2.5">
                <a href="#cards" className="text-sm text-background-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">院线大片</a>
                <a href="#cards" className="text-sm text-background-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">高分美剧</a>
                <a href="#cards" className="text-sm text-background-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">国产热剧</a>
                <a href="#cards" className="text-sm text-background-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">纪录片</a>
                <a href="#cards" className="text-sm text-background-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">动漫番剧</a>
              </nav>
            </div>

            <div>
              <h4 className="font-heading text-base font-bold text-background-50 mb-4">联系与支持</h4>
              <div className="flex flex-col gap-2.5">
                <a href="#contact" className="text-sm text-background-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">商务合作</a>
                <a href="#faq" className="text-sm text-background-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">常见问题</a>
                <a href="#about" className="text-sm text-background-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">关于我们</a>
                <a href="#app" className="text-sm text-background-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">移动客户端</a>
              </div>
            </div>
          </div>

          <div className="border-t border-background-700 pt-8 mb-8">
            <h4 className="font-heading text-sm font-bold text-background-300 mb-4">合作伙伴</h4>
            <p className="text-xs text-background-500">诚邀优质影视内容方与品牌方合作，共创4K超清观影生态。</p>
          </div>

          <div className="border-t border-background-700 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; 2025 555电影网 版权所有 | 极致画质 · 流畅观影
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-background-500 hover:text-background-300 cursor-pointer transition-colors whitespace-nowrap">用户协议</a>
              <a href="#" className="text-xs text-background-500 hover:text-background-300 cursor-pointer transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-xs text-background-500 hover:text-background-300 cursor-pointer transition-colors whitespace-nowrap">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}